import { Paper, Skeleton } from "@mui/material";
import React from "react";
import { SwiperSlide } from "swiper/react";
import { useCoreRequestProvider } from "../../providers/RequestProvider";
import { useThemeProvider } from "../../providers/ThemeProvider";
import { LinkValues, ResponseValues } from "../../values/strings";
import {
  SimpleCarouselComponent,
  SimpleSliderCarouselComponent,
} from "./SimpleCarouselComponent";

const MainHeaderCarouselComponent = () => {
  const coreRequest = useCoreRequestProvider();
  const [banners, setBanners] = React.useState(null);
  React.useEffect(async () => {
    if (!banners) {
      const data = await coreRequest.get(LinkValues.core.appviews.banners());
      setBanners((data.data && data.data.data) || null);
    }
  }, [banners]);

  return (
    <>
      {(banners && (
        <SimpleCarouselComponent
          autoplay={true}
          navigation={true}
          pagination={true}
        >
          {banners.map((item, i) => (
            <SwiperSlide key={i}>
              <a
                href={item[ResponseValues.targetLink]}
                style={{ width: "100%" }}
              >
                <img
                  src={item[ResponseValues.imageUrl]}
                  alt={item[ResponseValues.title]}
                  title={item[ResponseValues.title]}
                />
              </a>
            </SwiperSlide>
          ))}
        </SimpleCarouselComponent>
      )) || (
        <Skeleton
          height={400}
          width="100%"
          animation="wave"
          variant="rectangular"
        />
      )}
    </>
  );
};

export default MainHeaderCarouselComponent;
